import React from 'react';
import { useEffect, useRef, useState } from 'react';
import './autoscroll.css';

interface AutoScrollProps {
    children: React.ReactNode;
}

const AutoScroll: React.FC<AutoScrollProps> = ({ children }) => {
    const scrollableDivRef = useRef<HTMLDivElement>(null);
    const [isUserScrolling, setIsUserScrolling] = useState(false);
    const [scrollDirection, setScrollDirection] = useState(1); // 1 for down, -1 for up

    useEffect(() => {
        const scrollableDiv = scrollableDivRef.current;

        if (!scrollableDiv) return;

        const autoScroll = () => {
            if (!isUserScrolling) {
                if (scrollableDiv.scrollTop + scrollableDiv.clientHeight >= scrollableDiv.scrollHeight) {
                    setScrollDirection(-1);
                } else if (scrollableDiv.scrollTop <= 0) {
                    setScrollDirection(1);
                }
                scrollableDiv.scrollBy({
                    top: scrollDirection,
                    behavior: 'smooth'
                });
            }
        };

        const scrollInterval = setInterval(autoScroll, 50);

        const handleScroll = () => {
            setIsUserScrolling(true);
            clearInterval(scrollInterval);
        };

        const handleMouseOver = () => {
            setIsUserScrolling(true);
            clearInterval(scrollInterval);
        };

        const handleMouseLeave = () => {
            setIsUserScrolling(false);
            setInterval(autoScroll, 50);
        };

        scrollableDiv.addEventListener('scroll', handleScroll);
        scrollableDiv.addEventListener('mouseover', handleMouseOver);
        scrollableDiv.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            clearInterval(scrollInterval);
            scrollableDiv.removeEventListener('scroll', handleScroll);
            scrollableDiv.removeEventListener('mouseover', handleMouseOver);
            scrollableDiv.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [isUserScrolling, scrollDirection]);

    return (
        <div className="auto-scroll-div" ref={scrollableDivRef}>
            {children}
        </div>
    );
};

export default AutoScroll;